import { createSlice } from "@reduxjs/toolkit";
import {
    getStopOrder,
    updateStopOrder,
    getStopOrderGenerationReport,
} from "./actions/stopOrderActions.js";

const initialState = {
  loading: false,
  stopOrderUsers:null,
  
  stopOrderByPush: null,
  totalByStopOrder: 0,
  stopOrderFilters: {},
  stopOrderPageState: { page: 1, pageSize: 50 },

  stopOrderByPushReport: null,
  totalByStopOrderReport: 0,
  stopOrderReportFilters: {},
  stopOrderReportPageState: { page: 1, pageSize: 50 },
};

export const stopOrderSlice = createSlice({
  name: "stoporder",
  initialState,
  reducers: {
    setStopOrderFilters: (state, action) => {
        const { payload } = action;
        state.stopOrderFilters = payload || {};
      },
      resetStopOrderFilters: (state) => {
        state.stopOrderFilters = {};
      },
      setStopOrderPage: (state, action) => {
        const { page, pageSize } = action.payload;
        if (page) {
          state.stopOrderPageState = {
            ...state.stopOrderPageState,
            page,
          };
        }
        if (pageSize) {
          state.stopOrderPageState = {
            ...state.stopOrderPageState,
            pageSize,
          };
        }
      },

  },
  extraReducers: (builder) => {
    builder
    .addCase(getStopOrder.pending, (state) => {
      state.loading = true;
    })
    .addCase(getStopOrder.fulfilled, (state, action) => {
      const { data, count,user } = action.payload;
      state.loading = false;
      state.stopOrderByPush = data;
      state.stopOrderUsers = user;
      state.totalByStopOrder = count;
    })
    .addCase(getStopOrder.rejected, (state) => {
      state.loading = false;
    });
    builder
      .addCase(updateStopOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStopOrder.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.stopOrderByPush = data;
        state.stopOrderUsers = user;
        state.totalByLimitApproval = count;
      })
      .addCase(updateStopOrder.rejected, (state) => {
        state.loading = false;
      });
      builder
      .addCase(getStopOrderGenerationReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getStopOrderGenerationReport.fulfilled,
        (state, action) => {
          const { data, count, user } = action.payload;
          state.loading = false;
          state.stopOrderByPushReport = data;
          state.stopOrderUsers = user;
          state.totalByStopOrderReport = count;
        }
      )
      .addCase(getStopOrderGenerationReport.rejected, (state) => {
        state.loading = false;
      });
    },  
});

export const {

  resetStopOrderFilters,
  setStopOrderFilters,
  setStopOrderPage,

} = stopOrderSlice.actions;

export default stopOrderSlice.reducer;
